import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'

import { EUserRole } from '@shared/api/user-management/resources/user/constants/user-roles'

export const notifications = [
  {
    path: '/notifications',
    name: ERouterList.NOTIFICATIONS,
    component: () => import('@internal/pages/notifications/index.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN, EUserRole.PRACTICE_CLINICIAN],
      layout: InnerLayout,
    },
  },
  {
    path: '/notifications/:id/review-consent',
    name: ERouterList.NOTIFICATIONS_REVIEW_CONSENT,
    component: () => import('@internal/pages/notifications/_id/review-consent.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN, EUserRole.PRACTICE_CLINICIAN],
      layout: InnerLayout,
    },
  },
  {
    path: '/notifications/:id/review-insurance',
    name: ERouterList.NOTIFICATIONS_REVIEW_INSURANCE,
    component: () => import('@internal/pages/notifications/_id/review-insurance.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN, EUserRole.PRACTICE_CLINICIAN],
      layout: InnerLayout,
    },
  },
  {
    path: '/notifications/:id/resolve-duplicate-residents',
    name: ERouterList.NOTIFICATIONS_RESOLVE_DUPLCATE_RESIDENTS,
    component: () => import('@internal/pages/notifications/_id/resolve-duplicate-residents.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN, EUserRole.PRACTICE_CLINICIAN],
      layout: InnerLayout,
    },
  },
]

export default notifications
